/**
 * Author(s) : Karthik
 * Purpose : This imageCardsContainer used to create responsive image cards layout.
 */
import React from 'react'
import Image from '../../components/imageCard/ImageCard';
import PropTypes from "prop-types";

const ImageCards = (props) => {
  const details=props.details;
 
  return (
    <div className="imageCardsContainer">
    {details.map((detail, index) => {
      const {imageUrl, name, designation=null} = detail;
        return (
          <div className="imageWrapper" key={index}>
            <Image
              imageURL={imageUrl}
              name={name}
              designation={designation}
            />
          </div>
        );
      })}
    </div>
  );
}

export default ImageCards;
ImageCards.propTypes = {
  details: PropTypes.array
}
